<template>
    <div id="app">
        <component :is="componentName"></component>
        <router-view v-cloak></router-view>
    </div>
</template>

<style type="text/css">
[v-cloak] {
    display: none !important;
}
</style>

<script>
import 'veui-theme-one/common.less';
import 'font-awesome/css/font-awesome.min.css';

import Header from '@/components/Header';
import DocHeader from '@/components/DocHeader';

export default {
    name: 'App',
    data() {
        return {
            // 为避免头部加载抖动，初始状态设为空
            componentName: ''
        };
    },
    watch: {
        $route(to, from) {
            // 监听是否为文档搜索来源
            if (to.name === 'search' && to.query.source === 'docs') {
                this.componentName = DocHeader;
            } else {
                this.componentName = Header;
            }
        }
    }
};
</script>
